// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { fnBind, getDeferred } from "@nevware21/ts-utils";
import { _DYN_GET_ACTIVE_SPAN, _DYN_SET_ACTIVE_SPAN } from "../../../__DynamicConstants";
import { UNDEFINED_VALUE } from "../../../constants/InternalConstants";
import { setProtoTypeName } from "../../../utils/HelperFuncs";
import { throwOTelError } from "../errors/OTelError";
import { isSpanContextValid, wrapSpanContext } from "./utils";
/**
 * @internal
 * Create a new instance of the OpenTelemetry Trace API, this is bound to the
 * provided instance of the traceProvider (the {@link IOTelApi} instance),
 * to "change" (setGlobalTraceProvider) you MUST create a new instance of this API.
 * @param otelApi - The IOTelApi instance associated with this instance
 * @returns A new instance of the ITraceApi for the provided ITelApi
 */
export function _createTraceApi(otelApi) {
    var traceProvider = otelApi;
    if (!traceProvider) {
        throwOTelError("Must provide an otelApi instance");
    }
    return getDeferred(function () {
        return setProtoTypeName({
            getTracer: fnBind(traceProvider.getTracer, traceProvider),
            // We use fnBind to automatically inject the "otelApi" argument as the first argument to the wrapSpanContext function
            wrapSpanContext: fnBind(wrapSpanContext, UNDEFINED_VALUE, [otelApi]),
            isSpanContextValid: isSpanContextValid,
            getActiveSpan: function () {
                return otelApi.host ? otelApi.host[_DYN_GET_ACTIVE_SPAN /* @min:%2egetActiveSpan */]() : null;
            },
            setActiveSpan: function (span) {
                return otelApi.host ? otelApi.host[_DYN_SET_ACTIVE_SPAN /* @min:%2esetActiveSpan */](span) : null;
            }
        }, "TraceApi");
    });
}
//# sourceMappingURL=traceApi.js.map